module.exports = __webpack_public_path__ + "img/karaoke.ec492247.png";